import { FileEdit, Tags } from 'lucide-react';
import { useState } from 'react';

import ScheduleTestForm from '../components/sheduleTest/ScheduleTestForm';
import ScheduleTestsTable from '../components/sheduleTest/ScheduleTestsTable';
import TestSummary from '../components/sheduleTest/TestSummary';
import TagManagementScreen from '../components/Tags/TagManagementScreen';

export type Test = {
  id: string;
  assignedStudentIds: string[];
  companyId: string;
  testName: string;
  organizerId: string;
  status: 'Active' | 'Upcoming' | 'Completed';
  tagId: string;
  createdDate: string;
  testStartTime: string;
  testEndTime: string;
  tenantId: string;
  testStatus: string;
};

const ScheduleTestManagementDashboard = () => {
  const [currentScreen, setCurrentScreen] = useState<
    'dashboard' | 'form' | 'assignees'
  >('dashboard');

  const [tests, setTests] = useState<Test[]>([]);
  const [screen, setScreen] = useState<'dashboard' | 'tags'>('dashboard');

  const handleAddNewTest = () => {
    setCurrentScreen('form');
  };

  if (currentScreen === 'form') {
    return <ScheduleTestForm setCurrentScreen={setCurrentScreen} />;
  }

  if (screen === 'tags') {
    return <TagManagementScreen onBack={() => setScreen('dashboard')} />;
  }

  return (
    <div className='min-h-screen bg-gray-50 p-8'>
      <div className='mx-auto max-w-5xl'>
        <div className='mb-8 flex gap-3'>
          <button
            onClick={() => setScreen('dashboard')}
            className='flex items-center gap-2 rounded-lg bg-blue-600 px-5 py-2.5 font-semibold text-white shadow-sm'
          >
            <FileEdit className='h-5 w-5' />
            Tests Dashboard
          </button>
          <button
            onClick={() => setScreen('tags')}
            className='flex items-center gap-2 rounded-lg bg-white px-5 py-2.5 font-semibold text-gray-700 shadow-sm hover:bg-gray-50'
          >
            <Tags className='h-5 w-5' />
            Manage Batches
          </button>
        </div>
        {/* Status Cards */}
        <TestSummary />

        {/* Scheduled Tests Section */}
        <ScheduleTestsTable
          handleAddNewTest={handleAddNewTest}
          tests={tests}
          setTests={setTests}
        />
      </div>
    </div>
  );
};

export default ScheduleTestManagementDashboard;
